/*
 * @Author: lisl27
 * @Date: 2021-11-29 15:31:44
 * @LastEditors: lisl27
 * @LastEditTime: 2021-11-29 17:54:01
 * @Description: file content
 */
import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics, Utils } from '../../helpers';
import { BasesController } from '../bases';

export class ReportDetailController extends BasesController<any> {
  constructor(public CommonController) {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      details: EnumAPI.business_reportDetail,
      detailsParams: {
        valueGetter: this.valueGetter,
      },
    });
  }
  async parseCodeData(response) {
    const {
      customerInfo: { agentPosition },
      quotationBusiness: { winRate },
    } = response;
    await this.CommonController.onGetwinRateList();
    await this.CommonController.onGetAagentPositionList();

    const curAgentPosition =
      lodash.find(this.CommonController.agentPositionList, (item) => {
        return item.value == agentPosition;
      }) || {};
    const curWinRate =
      lodash.find(this.CommonController.winRateList, (item) => {
        return item.value == winRate;
      }) || {};
    return { agentPosition: curAgentPosition.label, winRate: curWinRate.label };
  }

  valueGetter = async (response, AjaxConfig) => {
    const {
      quotationBusiness,
      quotationBusiness: { reportProvinceName, reportCityName },
      customerInfo,
      customerInfo: { provinceName, cityName },
      productList,
      priceCode,
      liveTime,
    } = response;
    const codeData = await this.parseCodeData(response);
    const totalPrice = lodash.sumBy(productList, (item: any) => {
      return item.price * item.number;
    });
    const totalNumber = lodash.sumBy(productList, (item: any) => {
      return parseInt(item.number);
    });
    lodash.assign(response, {
      _busInfo: lodash.assign({}, customerInfo, quotationBusiness, {
        liveTime: liveTime,
        priceCode: priceCode,
        _budget: quotationBusiness.budget
          ? Utils.currency(quotationBusiness.budget)
          : '',
        addressName: reportProvinceName
          ? `${reportProvinceName}${reportCityName}`
          : '',
        cAddressName: provinceName ? `${provinceName}${cityName}` : '',
        _agentPosition: codeData.agentPosition,
        _winRate: codeData.winRate,
      }),
      _productList: productList,
      totalPrice: totalPrice.toFixed(2),
      totalNumber: totalNumber,
    });
    return response;
  };
  /**
   * @des 拒单
   */
  async onBusinessRefuseOrder(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_refuseOrder,
      body,
    });
  }
  /**
   * @des 检测报价单有效期
   */
  async onBusinessCheckPriceSheet(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_checkPriceSheet,
      body,
    });
  }
}
